import MUIPopover, { PopoverProps } from "@mui/material/Popover";
import React, { FC } from "react";

export const Popover: FC<PopoverProps> = (props) => <MUIPopover {...(props as any)} />;
